<template>
    <div class="col">

        <div id="main"
             class="col-main">

            <div class="row no-gutters row-main justify-content-center">

                <div class="col-12 col-lg-10 bg-white">

                    <div class="row no-gutters justify-content-center">
                        <div class="col-12 col-lg-9">
                            <h2 class="section-title">Our Mission & Value Statements</h2>
                        </div>

                        <div class="col-12 col-lg-9">

                            <ul class="list-group list-group-flush">
                                <li class="list-group-item">
                                    <h4 class="section-title">Mission Statement</h4>
                                    <p class="h5">At Ealing Trailfinders Cricket Club we take great pride in our goal to
                                                  build a club that represents all sectors of the community. All our
                                                  adult and junior members know we are One club with a joint
                                                  mission.</p>
                                </li>

                                <li class="list-group-item">
                                    <h4 class="section-title">Our Value Statement</h4>
                                    <p class="h5">Members of our club should have PRIDE in the club and the facility.
                                                  They should respect one another, officials and opposition teams and
                                                  their guests and epitomize the spirit of cricket both on and off the
                                                  pitch. They believe in the team and in teamwork at the club and are
                                                  ambassadors for Ealing Trailfinders CC.</p>
                                </li>

                            </ul>


                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>
<script>
    export default {
        // data() {
        //     return {
        //         model: {}
        //     }
        // },
        // methods: {
        //     fetchList() {
        //         fetchUser('5e42c8d3a366ce0f8dfc4bf9')
        //             .then(response => {
        //                 this.model = response;
        //             })
        //     },
        // }
    }
</script>
<style>
</style>
